import type { Review } from "@/types/movie";

export const reviews: Review[] = [
  {
    id: "rv-01",
    movieId: "star-echo",
    author: "影迷·银河拾荒者",
    rating: 9.2,
    date: "2026-10-12",
    content:
      "本以为又是一部靠视效撑场的科幻片，没想到最打动我的是那句“回信需要二十年才能抵达”。导演把宏大的宇宙拍成了一个人的等待，看完久久无法平静。",
    likes: 428,
  },
  {
    id: "rv-02",
    movieId: "star-echo",
    author: "影评人 白桦",
    rating: 8.8,
    date: "2026-10-11",
    content:
      "时间悖论的设定并不算新，但影片用极其克制的叙事把情感放到了第一位。星际寂寥的镜头语言与细腻的人物关系形成强烈反差，是近年少见的“有呼吸感”的科幻。",
    likes: 512,
  },
  {
    id: "rv-03",
    movieId: "long-night",
    author: "夜行者",
    rating: 8.9,
    date: "2026-10-08",
    content:
      "动作场面干净利落，没有多余的炫技，每一场打斗都在推动剧情。赵寒声这次把卧底的疲惫与隐忍演活了，雨夜天台那场戏值得反复看。",
    likes: 366,
  },
  {
    id: "rv-04",
    movieId: "blue-whale",
    author: "海洋记录员",
    rating: 9.4,
    date: "2026-10-10",
    content:
      "在影院里几乎能听见自己屏住呼吸的声音。水下摄影美到不真实，但真正让人沉默的，是结尾那段关于塑料微粒的影像。强烈建议带孩子一起看。",
    likes: 689,
  },
  {
    id: "rv-05",
    movieId: "seventh-suspect",
    author: "推理爱好者 阿哲",
    rating: 8.7,
    date: "2026-10-09",
    content:
      "本格粉丝狂喜。前半小时交代人物有点慢，但从第一具尸体出现开始就完全停不下来。最后一层反转虽然猜到一半，但动机部分确实惊艳。",
    likes: 402,
  },
  {
    id: "rv-06",
    movieId: "seventh-suspect",
    author: "影评人 陈默",
    rating: 8.5,
    date: "2026-10-10",
    content:
      "密室的封闭感与七人之间的猜忌构成了绝佳张力。影片聪明的地方在于：它让你怀疑每一个人，最后却让你怀疑自己。",
    likes: 331,
  },
  {
    id: "rv-07",
    movieId: "mother-stitch",
    author: "想家的人",
    rating: 9.1,
    date: "2026-10-08",
    content:
      "看预告片时觉得会很煽情，结果正片极其克制。母亲缝衣服的手部特写反复出现，没有一句台词，却把一辈子的牵挂都说了。散场后我立刻给妈妈打了电话。",
    likes: 574,
  },
  {
    id: "rv-08",
    movieId: "time-fold",
    author: "概念控",
    rating: 8.6,
    date: "2026-10-04",
    content:
      "结构精妙到需要二刷。第一次看是悬疑，第二次看是悲剧。每次穿越付出的代价，其实都在暗示“接受遗憾”才是真正的答案。",
    likes: 388,
  },
  {
    id: "rv-09",
    movieId: "dark-current",
    author: "刑侦剧迷",
    rating: 8.4,
    date: "2026-10-03",
    content:
      "三条时间线交织得毫不凌乱，二十年悬案与当下案件的呼应堪称教科书级别。老刑警那句“查案的人也是网中的鱼”，后劲太大了。",
    likes: 295,
  },
  {
    id: "rv-10",
    movieId: "mountain-sea-scroll",
    author: "国风爱好者",
    rating: 8.9,
    date: "2026-10-07",
    content:
      "水墨质感的三维渲染太美了，异兽出场那一刻全影院都在小声惊叹。不只是画面，故事里“修补绘卷就是修补记忆”的设定也很有余味。",
    likes: 447,
  },
  {
    id: "rv-11",
    movieId: "laugh-life",
    author: "打工人小李",
    rating: 7.8,
    date: "2026-10-05",
    content:
      "笑点很密集但不廉价，被裁员那段几乎全场爆笑又有点想哭。中年人的狼狈拍得真实，看完压力都小了不少。",
    likes: 210,
  },
  {
    id: "rv-12",
    movieId: "snowfall-silent",
    author: "冬日限定",
    rating: 7.9,
    date: "2026-10-02",
    content:
      "节奏很慢，但很适合冬天窝在沙发里看。久别重逢的处理没有刻意煽情，反而因为克制而更动人。",
    likes: 168,
  },
  {
    id: "rv-13",
    movieId: "mountain-dream",
    author: "影评人 南山",
    rating: 8.5,
    date: "2026-10-06",
    content:
      "四十年、三代人、一片山林。影片没有宏大口号，只有群山之间沉默的坚守。最后那个航拍长镜头，把“故土”两个字拍进了心里。",
    likes: 356,
  },
  {
    id: "rv-14",
    movieId: "city-above-clouds",
    author: "科幻迷 阿澈",
    rating: 8.3,
    date: "2026-10-01",
    content:
      "乌托邦外壳下藏着锋利的追问：完美世界的代价由谁承担？视效不必多说，难得的是它愿意停下来讨论“代价”，而不是一味追逐奇观。",
    likes: 274,
  },
  {
    id: "rv-15",
    movieId: "hunt-shadow",
    author: "追片族",
    rating: 8.1,
    date: "2026-09-28",
    content:
      " rooftops 追逐那段长镜头一气呵成，看得很爽。剧情稍显简单，但动作设计和配乐把节奏拉满，爆米花电影里的上乘之作。",
    likes: 191,
  },
  {
    id: "rv-16",
    movieId: "iron-dawn",
    author: "热血不减",
    rating: 8.0,
    date: "2026-09-26",
    content:
      "父女线是全片的灵魂，擂台戏反而成了情感的注脚。最后一拳的镜头处理很有力量，散场时手还是抖的。",
    likes: 203,
  },
];